// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"gJ-z","carouselContainer":"hJ-z"};